import { DittoKeys } from '../i18n/i18n';
import { links } from './links';
import { PathKeys } from './paths';

export type RouteHandle = {
  /** Page title and H1 heading in header */
  title: DittoKeys;
  /** Name of breadcrumb, if any */
  crumb?: DittoKeys;
  /** Used if a bigger header should be used instead, which includes a subtitle and optional link */
  bigHeader?: {
    subTitle: DittoKeys;
    link?: { name: DittoKeys; to: string };
  };
};

export const routeHandles: { [key in PathKeys]: RouteHandle } = {
  payroll: {
    title: 'common.serviceNames.manualReporting',
    crumb: 'crumbs.start',
  },
  payrollHelp: {
    title: 'common.serviceNames.manualReporting',
    // No crumbs on the help pages
  },
  reportPayroll: {
    title: 'common.serviceNames.manualReporting',
    crumb: 'crumbs.reportPayroll',
  },
  employments: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.start',
  },
  employmentsHelp: {
    title: 'common.serviceNames.employments',
  },
  addEmployment: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.addEmployee',
  },
  editEmployment: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.editEmployee',
  },
  editEmployee: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.editEmployee',
  },
  addEmployee: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.addEmployee',
  },
  editEmploymentPeriod: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.editEmployment',
  },
  addEmploymentPeriod: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.addEmployment',
  },
  editParameter: {
    title: 'common.serviceNames.employments',
    crumb: 'crumbs.editParameter',
  },
  invoices: {
    title: 'common.serviceNames.invoices',
    crumb: 'crumbs.start',
  },
  invoicesHelp: {
    title: 'common.serviceNames.invoices',
  },
  markups: {
    title: 'common.serviceNames.markups',
    crumb: 'crumbs.start',
  },
  fileDashboard: {
    title: 'fileDashboard.header.title',
    crumb: 'crumbs.start',
    bigHeader: {
      subTitle: 'hero.multiReporterOverview',
      link: { name: 'payroll.descriptionLinkText', to: links.fileDashboardHelp },
    },
  },
  fileDashboardHelp: {
    title: 'fileDashboard.header.title',
  },
  payHistory: {
    title: 'fileDashboard.header.title',
    crumb: 'crumbs.payrollHistory',
  },
  reportHistory: {
    title: 'fileDashboard.header.title',
    crumb: 'crumbs.reportLog',
  },
};
